import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Instagram, Facebook, Linkedin } from "lucide-react";
import { IMAGES } from "../config";

const Footer = () => {
  return (
    <footer className="bg-[#1a1a1a] text-white py-12 md:py-16" role="contentinfo">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12 mb-8 md:mb-12">
          <div className="md:col-span-2 lg:col-span-2">
            <div className="flex items-center gap-3 md:gap-4 mb-4 md:mb-6">
              <img src={IMAGES.barspotLogoRound} alt="" className="h-12 w-12 md:h-16 md:w-16 rounded-full" aria-hidden="true" />
              <div>
                <h2 className="text-lg md:text-xl font-bold text-[#a5dae0]">BAR SPOT</h2>
                <p className="text-white/70 text-sm">Mobile Bar Hire</p>
              </div>
            </div>
            <p className="text-white/70 max-w-md leading-relaxed text-sm md:text-base">
              Premium mobile bar hire for weddings, corporate events, and festivals across the UK.
              Stylish, flexible, and full of character.
            </p>
            <div className="flex gap-4 mt-4 md:mt-6">
              <a href="https://facebook.com/Barspotuk" target="_blank" rel="noopener noreferrer" data-testid="footer-facebook" aria-label="Follow us on Facebook @Barspotuk" className="text-white/70 hover:text-[#a5dae0] transition-colors focus:outline-none focus:ring-2 focus:ring-[#a5dae0] rounded p-1">
                <Facebook size={22} aria-hidden="true" />
              </a>
              <a href="https://instagram.com/Barspotuk" target="_blank" rel="noopener noreferrer" data-testid="footer-instagram" aria-label="Follow us on Instagram @Barspotuk" className="text-white/70 hover:text-[#a5dae0] transition-colors focus:outline-none focus:ring-2 focus:ring-[#a5dae0] rounded p-1">
                <Instagram size={22} aria-hidden="true" />
              </a>
              <a href="https://www.linkedin.com/company/66876161" target="_blank" rel="noopener noreferrer" data-testid="footer-linkedin" aria-label="Follow us on LinkedIn @Barspotuk" className="text-white/70 hover:text-[#a5dae0] transition-colors focus:outline-none focus:ring-2 focus:ring-[#a5dae0] rounded p-1">
                <Linkedin size={22} aria-hidden="true" />
              </a>
            </div>
          </div>

          <nav aria-label="Services">
            <h3 className="font-semibold mb-3 md:mb-4 text-white">Services</h3>
            <ul className="space-y-2">
              <li><Link to="/weddings" className="text-white/70 hover:text-[#a5dae0] transition-colors focus:outline-none focus:ring-2 focus:ring-[#a5dae0] rounded px-1 text-sm md:text-base">Wedding Bar Hire</Link></li>
              <li><Link to="/private-hire" className="text-white/70 hover:text-[#a5dae0] transition-colors focus:outline-none focus:ring-2 focus:ring-[#a5dae0] rounded px-1 text-sm md:text-base">Private & Corporate</Link></li>
              <li><Link to="/festivals" className="text-white/70 hover:text-[#a5dae0] transition-colors focus:outline-none focus:ring-2 focus:ring-[#a5dae0] rounded px-1 text-sm md:text-base">Festival & Events</Link></li>
              <li><Link to="/menu" className="text-white/70 hover:text-[#a5dae0] transition-colors focus:outline-none focus:ring-2 focus:ring-[#a5dae0] rounded px-1 text-sm md:text-base">Drinks Menu</Link></li>
            </ul>
          </nav>

          <div>
            <h3 className="font-semibold mb-3 md:mb-4 text-white">Contact</h3>
            <ul className="space-y-2 md:space-y-3">
              <li className="flex items-center gap-2 md:gap-3 text-white/70">
                <Phone size={16} aria-hidden="true" />
                <a href="tel:07554856712" className="hover:text-[#a5dae0] transition-colors focus:outline-none focus:ring-2 focus:ring-[#a5dae0] rounded text-sm md:text-base">07554 856712</a>
              </li>
              <li className="flex items-center gap-2 md:gap-3 text-white/70">
                <Mail size={16} aria-hidden="true" />
                <a href="mailto:hello@barspotltd.co.uk" className="hover:text-[#a5dae0] transition-colors focus:outline-none focus:ring-2 focus:ring-[#a5dae0] rounded text-sm md:text-base break-all">hello@barspotltd.co.uk</a>
              </li>
              <li className="flex items-start gap-2 md:gap-3 text-white/70">
                <MapPin size={16} className="mt-1 flex-shrink-0" aria-hidden="true" />
                <address className="not-italic text-sm md:text-base">Unit A, 82 James Carter Road,<br />Mildenhall, Suffolk, IP28 7DE</address>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-6 md:pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-white/50 text-xs md:text-sm text-center md:text-left">© 2020–2026 Bar Spot Ltd. All rights reserved. VAT: 935250727</p>
          <div className="flex gap-4 md:gap-6">
            <Link to="/about" data-testid="footer-about" className="text-white/50 text-xs md:text-sm hover:text-[#a5dae0] transition-colors focus:outline-none focus:ring-2 focus:ring-[#a5dae0] rounded px-1">About Us</Link>
            <Link to="/contact" data-testid="footer-contact" className="text-white/50 text-xs md:text-sm hover:text-[#a5dae0] transition-colors focus:outline-none focus:ring-2 focus:ring-[#a5dae0] rounded px-1">Contact</Link>
            <Link to="/privacy-policy" data-testid="footer-privacy" className="text-white/50 text-xs md:text-sm hover:text-[#a5dae0] transition-colors focus:outline-none focus:ring-2 focus:ring-[#a5dae0] rounded px-1">Privacy Policy</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
